import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import Groups from '@/views/groups/List.vue';

export const groupListRoute: RouteConfig = {
  path: 'groups',
  name: 'groups',
  component: Groups,
  beforeEnter: (to, from, next) => {
    store.dispatch('access/check', ['GROUP.UPDATE']).then(permissions => {
      if (!permissions[0]) {
        next({ name: 'profile' });
      }
      store
        .dispatch('groups/list', baseFilters(to))
        .then(() => {
          store.commit('breadcrumbs/set', [{ text: 'Grupy', disabled: true }]);
          next();
        })
        .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy grup.' }));
    });
  },
  meta: { toolbarTitle: 'Grupy mieszkańców' }
};
